import { render } from "./AccordionItem.vue?vue&type=template&id=0901ae98&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=0901ae98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0901ae98"

export default script